import { ErrorResponse, GlobalVariableValues, MessageParameters } from "@gtpl/shared-models/common-models";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import appSettings from "apps/services/config";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import moment from "moment";
import { Between, Repository, getManager} from "typeorm";
import { AssetByDate } from "../asset-assignment/dto/asset-by-date.dto";
import { AssetAssignment } from "../asset-assignment/entity/asset-assignment.entity";
import { AssetAssignmentRepository } from "../asset-assignment/repository/asset-assignment.repository";
import { AssetLocationMappingRepository } from "../asset-location-mapping/repository/asset-location-mapping.repository";
import { AssetsRepository } from "../open-assets/dto/opens-assets-repository";
import { Assets } from "../open-assets/open-assets-entity";
import { AssetMaintainanceAdapter } from "./asset-maintainance.adapter";
import { AssetById } from "./dto/asset-by-id.dto";
import {AssetByCode} from './dto/asset-by-code.dto';
import { AssetMaintainanceTransactionsDto } from "./dto/asset-maintainance-transactions.dto";
import { AssetMaintainanceDto } from "./dto/asset-maintainance.dto";
import { AssetMaintainanceTransactions } from "./entity/asset-maintainance-transactions.entity";
import { AssetMaintainance } from "./entity/asset-maintainance.entity";
import { AssetMaintainanceTrasactionsRepository } from "./repository/asset-maintainance-transactions.repository";
import { AssetMaintainanceRepository } from "./repository/asset-maintainance.repository";
import {AssetMaintainanceDto as MaintenanceDto} from 'libs/shared-models/asset-management/src/lib/asset-maintainance/asset-maintainance.dto';
import {AssetMaintainanceTransactionsDto as TransactionDto} from 'libs/shared-models/asset-management/src/lib/asset-maintainance/asset-maintainance-transactions.dto';
import { AssetTransaction } from "../open-assets/asset-transaction-entity";
import { AssetTransactionAdapter } from "../open-assets/dto/asset-transaction-adapter";
import { AssetTransactionDto } from "../open-assets/dto/asset-transaction-dto";
import { InjectRepository } from "@nestjs/typeorm";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import whatsApp from "apps/services/whatsapp";
import { WhatsAppLogDto } from "@gtpl/shared-models/whatsapp-broad-cast";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";

@Injectable()
export class AssetMaintainanceService {
    constructor(
        private assetMaintainanceRepo: AssetMaintainanceRepository,
        private assetAdapter: AssetMaintainanceAdapter,
        private assetMaintainaceTrans: AssetMaintainanceTrasactionsRepository,
        private assetAssignRepo: AssetAssignmentRepository,
        private assetRepo: AssetsRepository,
        private assetMappingRepo: AssetLocationMappingRepository,
        @InjectRepository(AssetTransaction)
        private assetsTransactionRepo: Repository<AssetTransaction>,
        private assetTransAdapter : AssetTransactionAdapter,
        private wpService: WhatsAppNotificationService,
        private wtsAppBroadCatService:WhatsappBroadCastService,

    ) { }

    async createAssetMaintainance(createDto: AssetMaintainanceDto): Promise<CommonResponse> {
       //const  getDto : AssetMaintainanceDto[] =[];
        try {
            // const maintainance = await this.isAssetMaintainance(createDto.assetId)
            const assetStatusObject = await this.assetRepo.findOne({where:{assetsCode:createDto.assetsCode}})
            let assetId:number;
            if(assetStatusObject.status !== 'Running'){
            if(assetStatusObject){
                const assetStatusUpdate = await this.assetRepo.update({assetId:assetStatusObject.assetId},{status:AssetStatusEnum.Idle,transactionDate:moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')})
                assetId = assetStatusObject.assetId;
            }
            const assetMaintainanceObject = await this.assetMaintainanceRepo.findOne({ where: { assetMaintainanceId: createDto.assetMaintainanceId },relations:['assetsId'] });
            let assetMaintainanceId: number;
            if (assetMaintainanceObject) {
                const assetMaintainanceUpdate = await this.assetMaintainanceRepo.update({ assetMaintainanceId: assetMaintainanceObject.assetMaintainanceId }, { status: AssetStatusEnum.Idle });
                assetMaintainanceId = assetMaintainanceObject.assetMaintainanceId
            } else {
                const entity = await this.assetAdapter.convertDtotoAssetMaintainanceEntity(createDto)
                const assetObject : {asset_id :number} = await this.assetRepo.createQueryBuilder('assets')
                .select('asset_id')
                .where(`assets_code = '${createDto.assetsCode}'`)
                .getRawOne();
                const assetCodeStatus = Number(assetObject.asset_id)
                entity.assetsId.assetId = assetCodeStatus;
                const assetMaintainanceSave = await this.assetMaintainanceRepo.save(entity)
              //  const convertedDto = this.assetAdapter.convertEntityToDto(entity)
              //  getDto.push(convertedDto)
              if(assetMaintainanceSave){
                const manager = getManager();
                let qry = `SELECT a.asset_id,a.assets_code AS assetCode,it.item_name AS assetName,am.maintainance_type AS maintainanceType,am.damage_reason AS Reason,am.expired_date AS expiredDate FROM ` + appSettings.assets_db + `.asset_maintainance am LEFT JOIN ` + appSettings.assets_db + `.assets a ON a.asset_id = am.asset_id LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name WHERE asset_maintainance_id = ${assetMaintainanceSave.assetMaintainanceId}`;
                const data = await manager.query(qry);
                const parameters = [
                    { "type": "text", "text": moment().format('DD-MM-YYYY') },
                    { "type": "text", "text": data[0].assetName ? data[0].assetName : "No Data" },
                    { "type": "text", "text": data[0].assetCode ? data[0].assetCode : "No Data" },
                    { "type": "text", "text": data[0].maintainanceType ? data[0].maintainanceType : "No Data" },
                    { "type": "text", "text": data[0].Reason ? data[0].Reason : "No Data" },
                    { "type": "text", "text": data[0].expiredDate ? moment(data[0].expiredDate).format('DD-MM-YYYY') : "No Data" },
                ];
                for (const contact of whatsApp.contacts) {
                    let statusFlag = true
                    const req = await new MessageParameters(contact, 'asset_maintenance_message', parameters, "en_us")
                    const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                    if (!messageStatus.status) {
                        statusFlag = false
                    }
                    else
                    {
                        const whatsapplogDto = new WhatsAppLogDto(contact,'asset_maintenance_message','Brandix_assets',GlobalVariableValues.assetmanagementcompanyId,GlobalVariableValues.assetManagementmoduleId)
                        await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                    }

                }
              }
              if(createDto.maintainanceType == 'Damaged'){
                const assetStatusUpdate = await this.assetRepo.update({assetId:assetStatusObject.assetId},{status:AssetStatusEnum.Damaged,transactionDate:moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')})
              } else {
                const assetStatusUpdate = await this.assetRepo.update({assetId:assetStatusObject.assetId},{status:AssetStatusEnum.Undermaintenance,maintenanceDueDate:createDto.expiredDate,transactionDate:createDto.expiredDate})
              }
                assetMaintainanceId = assetMaintainanceSave.assetMaintainanceId
            }
         //   const entity = await this.assetAdapter.convertDtotoAssetMaintainanceEntity(createDto)
                const assetObject : {asset_id :number} = await this.assetRepo.createQueryBuilder('assets')
                .select('asset_id')
                .where(`assets_code = '${createDto.assetsCode}'`)
                .getRawOne();
                const assetCodeStatus = Number(assetObject.asset_id)
            const transDto = new AssetMaintainanceTransactionsDto()
            transDto.assetMaintainanceId = assetMaintainanceId
            transDto.maintainanceType = createDto.maintainanceType;
            transDto.owner = createDto.owner;
            transDto.assetCondition = createDto.assetCondition;
            transDto.assetId = assetCodeStatus;
            transDto.assetLocationId = createDto.assetLocationId;
            transDto.assigned = createDto.assigned;
            transDto.damageReason = createDto.damageReason;
            transDto.costOfRepair = createDto.costOfRepair;
            transDto.maintainanceFrequencyInDays = createDto.maintainanceFrequencyInDays;
            transDto.remarks = createDto.remarks;
            const assetTransDto = new AssetTransactionDto();
            assetTransDto.assetId = assetCodeStatus;
            assetTransDto.maintenanceDueDate = createDto.expiredDate;
            assetTransDto.transactionDate = new Date();
            if(createDto.assetMaintainanceId){
                transDto.status = AssetStatusEnum.Idle
                assetTransDto.status = AssetStatusEnum.Idle;
                assetTransDto.maintenanceCost = Number(createDto.costOfRepair);
            } else {
                if(createDto.maintainanceType == 'Damaged'){
                    transDto.status = AssetStatusEnum.Damaged;
                    assetTransDto.status = AssetStatusEnum.Damaged;
                    assetTransDto.maintenanceCost = 0;                 
                } else {
                    transDto.status = AssetStatusEnum.Undermaintenance;
                    assetTransDto.status = AssetStatusEnum.Undermaintenance;
                    assetTransDto.maintenanceCost = Number(createDto.costOfRepair);
                }
            }
            const transEntiy = this.assetAdapter.convertDtotoAssetMaintainanceTransEntity(transDto)
            const assetMaintainanceTrans = await this.assetMaintainaceTrans.save(transEntiy)
            const assetTransactionEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
            const assetTransactionSave = await this.assetsTransactionRepo.save(assetTransactionEntity)
            return new CommonResponse(true, 11101, 'Created Successfully', assetMaintainanceTrans);
        } else {
            return new CommonResponse(false,9989,'Asset is assigned to someone')
        }

        } catch (err) {
            throw err;
        }
    
    }

    async updateAssetMaintainance(req: AssetMaintainanceDto): Promise<CommonResponse> {
        const updatemaintenance = await this.assetMaintainanceRepo.findOne({ where: { assetId: req.assetId } })
        if (!updatemaintenance) {
            return new CommonResponse(false, 99899, 'Asset Code not found')
        } else {
            const updateMaintenanceSave = await this.assetMaintainanceRepo.update({ assetMaintainanceId: updatemaintenance.assetMaintainanceId }, { costOfRepair: req.costOfRepair, expiredDate: req.expiredDate, status: AssetStatusEnum.Idle })
            const updateTrans = await this.assetMaintainaceTrans.findOne({ where: { assetId: req.assetId, status: 'INPROGRESS' } })
            if (updateTrans) {
                const updateTransSave = await this.assetMaintainaceTrans.update({ assetMaintainanceTransactionsId: updateTrans.assetMaintainanceTransactionsId }, { costOfRepair: req.costOfRepair, expiredDate: req.expiredDate, status: AssetStatusEnum.Idle })
            }
            return new CommonResponse(true, 1, 'Successfully updated')
        }
    }

    async getAllMaintainance(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT it.item_name,emp.employee_name,am.asset_id,am.maintainance_type,am.cost_of_repair,am.expired_date,am.remarks,aas.assets_name,aas.assets_code,aas.owner_of_asset,am.asset_maintainance_id 
        FROM `+appSettings.assets_db+`.asset_maintainance am
        LEFT JOIN `+appSettings.assets_db+`.assets aas ON aas.asset_id = am.asset_id
        LEFT JOIN `+appSettings.masters_db+`.items it ON it.item_id = aas.assets_name 
        LEFT JOIN `+appSettings.masters_db+`.employee_details emp ON emp.employee_id = aas.owner_of_asset 
        WHERE am.status='${AssetStatusEnum.Undermaintenance}'
        ORDER BY it.item_name ASC`
        const assetdata:{item_name: string,employee_name:string,asset_id:number,maintainance_type:string,cost_of_repair:string,expired_date: Date,remarks:string,assets_name:string,assets_code:string,owner_of_asset:string,asset_maintainance_id: number}[]= await manager.query(qry);
        const response =[];
        assetdata.forEach(data => {
            response.push(new MaintenanceDto(data.asset_maintainance_id,data.asset_id,null,null,null,null,data.maintainance_type,data.employee_name,data.expired_date,data.cost_of_repair,null,data.remarks,null,true,null,null,null,null,null,null,data.employee_name,data.item_name,data.assets_code))
        })
        return new CommonResponse(true,1,'Data retrieved successfully',response)
    }

    async getAllMaintainanceTrans(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT it.item_name,emp.employee_name,am.asset_id,am.maintainance_type,am.cost_of_repair,am.expired_date,am.remarks,am.damage_reason,am.created_at,am.updated_at,aas.assets_name,aas.assets_code,aas.owner_of_asset,aas.asset_category,isc.item_sub_category FROM `+appSettings.assets_db+`.asset_maintainance_transactions am
        LEFT JOIN `+appSettings.assets_db+`.assets aas ON aas.asset_id = am.asset_id
        LEFT JOIN `+appSettings.masters_db+`.items it ON it.item_id = aas.assets_name 
        LEFT JOIN `+appSettings.masters_db+`.employee_details emp ON emp.employee_id = aas.owner_of_asset 
        LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        ORDER BY it.item_name ASC`
        const assetdata:{item_name: string,employee_name:string,asset_id:number,maintainance_type:string,cost_of_repair:string,expired_date: Date,remarks:string,damage_reason:string,created_at:Date,updated_at:Date,assets_name:string,assets_code:string,owner_of_asset:string,item_sub_category:string}[]= await manager.query(qry);
        const response =[];
        assetdata.forEach(data => {
            response.push(new TransactionDto(null,null,data.asset_id,null,null,null,null,data.maintainance_type,data.employee_name,data.expired_date,data.cost_of_repair,data.damage_reason,data.remarks,null,true,data.created_at,null,data.updated_at,null,null,data.item_name,data.assets_code,data.employee_name,data.item_sub_category))
        })
        return new CommonResponse(true,1,'Data retrieved successfully',response)
    }

     async getTransById(req: AssetByCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT it.item_name,emp.employee_name,am.asset_id,am.maintainance_type,am.cost_of_repair,am.expired_date,am.remarks,am.damage_reason,am.created_at,am.updated_at,aas.assets_name,aas.assets_code,aas.owner_of_asset,aas.asset_category,isc.item_sub_category,isc.item_sub_category,aas.plant,unc.unit_name,aas.asset_type,loc.location_name,am.asset_id,aas.asset_mode
        FROM `+appSettings.assets_db+`.asset_maintainance_transactions am
        LEFT JOIN `+appSettings.assets_db+`.assets aas ON aas.asset_id = am.asset_id
        LEFT JOIN `+appSettings.masters_db+`.items it ON it.item_id = aas.assets_name 
        LEFT JOIN `+appSettings.masters_db+`.employee_details emp ON emp.employee_id = aas.owner_of_asset 
        LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        WHERE aas.asset_id >0 `
        if(req.assetsCode){
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode +'"'
        }
        if(req.plant){
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'"'
        }
        if(req.location){
            getEntities = getEntities + 'and loc.location_name = "' + req.location +'"'
        }
        if(req.assetType){
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType +'"'
        }
        if(req.assetCategory){
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory +'"'
        }
        if(req.plant && req.location){
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'" and loc.location_name = "' + req.location +'"'
        }
        if(req.plantId > 0 && req.plantId !=5 ){
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if(req.fromDate){
            getEntities = getEntities + 'and am.created_at BETWEEN "'+req.fromDate+'" AND "'+req.toDate+'"'

        }
        if(req.fromDate){
           getEntities = getEntities + ` ORDER BY am.created_at ASC `
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }
        const assetdata:{item_name: string,employee_name:string,asset_id:number,maintainance_type:string,cost_of_repair:string,expired_date: Date,remarks:string,damage_reason:string,created_at:Date,updated_at:Date,assets_name:string,assets_code:string,owner_of_asset:string,item_sub_category:string,unit_name:string,asset_type:string,location_name:string,asset_mode:string}[]= await manager.query(getEntities);
        const response =[];
        assetdata.forEach(data => {
            response.push(new TransactionDto(null,null,data.asset_id,null,null,null,null,data.maintainance_type,data.employee_name,data.expired_date,data.cost_of_repair,data.damage_reason,data.remarks,null,true,data.created_at,null,data.updated_at,null,null,data.item_name,data.assets_code,data.employee_name,data.item_sub_category,data.asset_type,data.unit_name,data.location_name,data.asset_mode))
        })
        return new CommonResponse(true,1,'Data retrieved successfully',response)
    }

     async getByAssetId(req: AssetByCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT it.item_name,emp.employee_name,am.asset_id,am.maintainance_type,am.cost_of_repair,am.expired_date,am.remarks,am.damage_reason,am.created_at,am.updated_at,aas.assets_name,aas.assets_code,aas.owner_of_asset,aas.asset_category,isc.item_sub_category,aas.plant,unc.unit_name,aas.asset_type,loc.location_name,aas.asset_invoice_no,aas.asset_serialno,
        am.asset_maintainance_id,aas.asset_mode FROM `+appSettings.assets_db+`.asset_maintainance am
        LEFT JOIN `+appSettings.assets_db+`.assets aas ON aas.asset_id = am.asset_id
        LEFT JOIN `+appSettings.masters_db+`.items it ON it.item_id = aas.assets_name 
        LEFT JOIN `+appSettings.masters_db+`.employee_details emp ON emp.employee_id = aas.owner_of_asset 
        LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        WHERE am.status='${AssetStatusEnum.Undermaintenance}'`
        if(req.assetsCode){
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode +'"'
        }
        // if(req.plant){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'"'
        // }
        if(req.location){
            getEntities = getEntities + 'and loc.location_name = "' + req.location +'"'
        }
        if(req.assetType){
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType +'"'
        }
        if(req.assetCategory){
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory +'"'
        }
        // if(req.plant && req.location){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'" and loc.location_name = "' + req.location +'"'
        // }
        if(req.plantId > 0 && req.plantId !=5 ){
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` ORDER BY am.expired_date ASC `

        const assetdata:{item_name: string,employee_name:string,asset_id:number,maintainance_type:string,cost_of_repair:string,expired_date: Date,remarks:string,damage_reason:string,created_at:Date,updated_at:Date,assets_name:string,assets_code:string,owner_of_asset:string,item_sub_category:string,asset_maintainance_id:number,unit_name:string,location_name,asset_type:string,asset_invoice_no:string,asset_serialno:string,asset_mode:string}[]= await manager.query(getEntities);
        const response =[];
        assetdata.forEach(data => {
            response.push(new MaintenanceDto(data.asset_maintainance_id,data.asset_id,null,null,null,null,data.maintainance_type,data.employee_name,data.expired_date,data.cost_of_repair,null,data.remarks,null,true,null,null,null,null,null,null,data.employee_name,data.item_name,data.assets_code,data.item_sub_category,data.unit_name,data.location_name,data.asset_type,data.asset_invoice_no,data.asset_serialno,data.asset_mode))
        })
        if(response.length > 0){
        return new CommonResponse(true,1,'Data retrieved successfully',response)
        } else{
            return new CommonResponse(false,99879,'No data found')
        }
    }

    async isAssetEligibleForLocation(assetId: number, locatioId: number): Promise<boolean> {
        const assetObj = new Assets();
        assetObj.assetId = assetId;

        const assetLocDetail = await this.assetMappingRepo.findOne({ where: { assetsId: assetObj } });
        if (assetLocDetail) {
            if (assetLocDetail.locationId == locatioId) {
                throw new ErrorResponse(11101, 'Asset is Already In the same location');
            }
        }
        // asset maintanance check
        const assetMaintainance = await this.assetMaintainanceRepo.findOne({ where: { assetsId: assetObj } })
        if (assetMaintainance) {
            if (assetMaintainance.status == 'Idle' || assetMaintainance.status == 'Running') {
                return true;
            } else {
                throw new ErrorResponse(11101, 'Asset is Already Under Maintainance you Cannnot Assign the Location')
            }
        }
        // user assigmet check
        // const assetAssign = await this.assetAssignRepo.findOne({ where: { assetsId: assetObj } });
        // if (assetAssign) {
        //     if (assetAssign.checkIn) {
        //         if (assetAssign.checkOut) {
        //             return true
        //         } else {
        //             throw new ErrorResponse(11101, 'Asset is Already Assigned to Some User You Cannot Assign the Location')
        //         }
        //     } else {
        //         return true
        //     }
        // }
        // asset value check
        // const assetExpiredDate = await this.assetRepo.findOne({where:{expiredDate:LessThan(Date.now())}})
        // if(assetExpiredDate){
        //     return true;
        // }else{
        //     throw new ErrorResponse(11101,'Asset is Already Expired, you Cannnot Assign the Location')
        // }

    }

    async isAssetUserAssignmentForCheckIn(assetId: number): Promise<boolean> {
        const assetObj = new Assets();
        assetObj.assetId = assetId;
        const assetLocationMapping = await this.assetMappingRepo.findOne({ where: { assetsId: assetObj } })
        if (assetLocationMapping) {
            if (!assetLocationMapping) {
                return false;
            }
        }
        const assetAssign = await this.assetAssignRepo.findOne({ where: { assetsId: assetObj } })
        if (assetAssign) {
            if (assetAssign.checkIn) {
                if (assetAssign.checkOut) {
                    return true
                } else {
                    throw new ErrorResponse(11101, 'Asset is Already Assigned to Some User You Cannot Assign Again')
                }
            } else {
                return true
            }
        }

        const assetMaintainance = await this.assetMaintainanceRepo.findOne({ where: { assetsId: assetObj } })
        if (assetMaintainance) {
            if (assetMaintainance.status == 'Idle') {
                return true;
            } else {
                throw new ErrorResponse(11101, 'Asset is Already Under Maintainance you Cannnot Assign Again')
            }
        }

        // const assetExpiredDate = await this.assetRepo.findOne({where:{expiredDate:LessThan(Date.now())}})
        // if(assetExpiredDate){
        //     return true;
        // }else{
        //     throw new ErrorResponse(11101,'Asset is Already Expired, you Cannnot Assign Again')
        // }

    }

    async isAssetUserAssignmentForCheckout(assetId: number): Promise<boolean> {
        const assetObj = new Assets();
        assetObj.assetId = assetId;
        const assetLocationMapping = await this.assetMappingRepo.findOne({ where: { assetsId: assetObj } })
        if (assetLocationMapping) {
            if (!assetLocationMapping) {
                return false;
            }
        }
        const assetAssign = await this.assetAssignRepo.findOne({ where: { assetsId: assetObj } })
        if (assetAssign) {
            if (assetAssign.checkIn) {
                if (!assetAssign.checkOut) {
                    return true
                } else {
                    throw new ErrorResponse(11101, 'Asset is Already Assigned to Some User You Cannot Assign Again')
                }
            } else {
                return true
            }
        }

        const assetMaintainance = await this.assetMaintainanceRepo.findOne({ where: { assetsId: assetObj } })
        if (assetMaintainance) {
            if (assetMaintainance.status == 'Idle') {
                return true;
            } else {
                throw new ErrorResponse(11101, 'Asset is Already Under Maintainance you Cannnot Assign Again')
            }
        }

        // const assetExpiredDate = await this.assetRepo.findOne({where:{expiredDate:LessThan(Date.now())}})
        // if(assetExpiredDate){
        //     return true;
        // }else{
        //     throw new ErrorResponse(11101,'Asset is Already Expired, you Cannnot Assign Again')
        // }

    }

    async isMaintainance(assetsCode:string) : Promise<boolean>{
        const assetObj = new Assets();
        assetObj.assetsCode = assetsCode;
        const assetLocationMapping = await this.assetMappingRepo.findOne({ where: { assetsId: assetObj } })
        if (assetLocationMapping) {
            if (!assetLocationMapping) {
                return false;
            }
        }
    }


    async isAssetMaintainance(assetId: number): Promise<boolean> {
        const assetObj = new Assets();
        assetObj.assetId = assetId;
        const assetLocationMapping = await this.assetMappingRepo.findOne({ where: { assetsId: assetObj } })
        if (assetLocationMapping) {
            if (!assetLocationMapping) {
                return false;
            }
        }
        const assetAssign = await this.assetAssignRepo.findOne({ where: { assetsId: assetObj } })
        if (assetAssign) {
            if (assetAssign.checkIn) {
                if (assetAssign.checkOut) {
                    return true
                } else {
                    throw new ErrorResponse(11101, 'Asset is Already Assigned to Some User You Cannot Assign Again')
                }
            } else {
                return true
            }
        }
    }

    async getByDate(req: AssetByDate) : Promise<CommonResponse> {
        const getReqDto : AssetMaintainanceTransactionsDto[] = [];
        const responseEntities = await this.assetMaintainaceTrans.find({
            where:{
                createdAt: Between(req.fromDate, req.toDate)
            }
        })
        if(responseEntities.length) {
            for(const entity of responseEntities){
            const convertedAssetDto = await this.assetAdapter.convertEntityToTransDto(entity)
            const qry = `select assets_name,assets_code,owner_of_asset,asset_category from ${appSettings.assets_db}.assets where asset_id = ${convertedAssetDto.assetId}`;
                const manager = getManager();
                const data: {assets_name:string; assets_code:string; owner_of_asset: number,asset_category:number}[] = await  manager.query(qry);
                convertedAssetDto.assetsName = data[0].assets_name;
                convertedAssetDto.assetsCode = data[0].assets_code;
                const qry1 = `select item_name from ${appSettings.masters_db}.items where item_id = ${convertedAssetDto.assetsName}`;
                const data1: {item_name: string}[] = await manager.query(qry1);
                convertedAssetDto.itemName = data1[0].item_name;
                const qry2  = `select employee_name from ${appSettings.masters_db}.employee_details where employee_id = ${data[0].owner_of_asset}`;
                const data2: {employee_name:string}[] = await manager.query(qry2);
                convertedAssetDto.employeeName = data2[0].employee_name;
                const qry3 = `select item_sub_category from ${appSettings.masters_db}.item_sub_categories where item_sub_category_id = ${data[0].asset_category}`;
                const data3: {item_sub_category:string}[] = await manager.query(qry3)
                convertedAssetDto.assetCategory = data3[0].item_sub_category;
                getReqDto.push(convertedAssetDto)
            }
            return new CommonResponse(true,98898,'Requests retrieved successfully',getReqDto );
        } else{
            return new CommonResponse(false, 11101, 'No data found');
        }

    }
    async getAssetCodesDropDownformaintance(req?:AssetByCode):Promise<CommonResponse>{
        const manager = getManager();
        let Query= 'SELECT i.item_name AS itemName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM '+appSettings.assets_db +`.asset_maintainance am left join `+appSettings.assets_db+`.assets a on a.asset_id=am.asset_id LEFT JOIN `+appSettings.masters_db+`.items i ON a.assets_name=i.item_id WHERE am.status="${AssetStatusEnum.Undermaintenance}" `;
        if(req.plantId > 0 && req.plantId !=5){
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY am.asset_id ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if(result.length>0){
            return new CommonResponse(true,11608,'Data Retrived Sucessfullyy.....',result)
        }
        else{
            return new CommonResponse(false,11608,'No data Found',result)
        }
    
    }

    async getAssetCodesDropDownformaintanancetrans(req?:AssetByCode):Promise<CommonResponse>{
        const manager = getManager();
        let Query= 'SELECT i.item_name AS itemName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM '+appSettings.assets_db +`.asset_maintainance_transactions am left join `+appSettings.assets_db+`.assets a on a.asset_id=am.asset_id LEFT JOIN `+appSettings.masters_db+`.items i ON a.assets_name=i.item_id WHERE am.status="${AssetStatusEnum.Undermaintenance}" `;
        if(req.plantId > 0 && req.plantId !=5){
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if(result.length>0){
            return new CommonResponse(true,11608,'Data Retrived Sucessfullyy.....',result)
        }
        else{
            return new CommonResponse(false,11608,'No data Found',result)
        }
    
    }
}